<script setup lang="ts">
import VTag from '~/components/ui/VTag.vue'

type Props = {
  contentArray: string[]
}

const props = defineProps<Props>()

const pillNames = computed(() => props.contentArray.slice(0, 8))
</script>

<template>
  <div class="tw-relative tw-flex tw-w-full tw-flex-wrap tw-gap-2 tw-self-end">
    <VTag v-for="pillName in pillNames" :key="pillName" :label="pillName" />
  </div>
</template>
